import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { supabase } from "@/integrations/supabase/client";
import { normalizeLanguage, type SupportedLanguage } from "@/i18n";
import { LOCALES, LOCALE_LABEL } from "@/lib/locale";
import { useAuth } from "@/hooks/useAuth";

export const languageOptions: Array<{ value: SupportedLanguage; label: string }> = LOCALES.map((value) => ({
  value,
  label: LOCALE_LABEL[value],
}));

export function useLanguagePreference() {
  const { i18n } = useTranslation();
  const { user } = useAuth();

  const changeLanguage = useCallback(
    async (language: SupportedLanguage) => {
      const nextLanguage = normalizeLanguage(language) ?? "fr";
      await i18n.changeLanguage(nextLanguage);
      localStorage.setItem("ui_language", nextLanguage);

      if (user) {
        await supabase
          .from("profiles")
          .update({ language_preference: nextLanguage } as any)
          .eq("id", user.id);
      }
    },
    [i18n, user],
  );

  return {
    language: normalizeLanguage(i18n.language) ?? "fr",
    changeLanguage,
    options: languageOptions,
  };
}
